// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__VZ9wu","powerBy":"Footer_powerBy__KsVGf","userInformation":"Footer_userInformation__LGism","share":"Footer_share__2Eqiz","shareIcon":"Footer_shareIcon__13vLd"};